import React, {useCallback} from 'react';
import cx from 'classnames';
import {PriorityIcon, Text, Icon} from '@priority-software/priority-style-react';
import styles from './styles.module.scss';

export type StepProps = {
    id: string;
    title: string;
    semiFilled?: boolean;
    isFinished?: boolean;
    isActive: boolean;
    index: number;
    disabled?: boolean;
    onClick: (id: string) => void;
};

export const Step = (props: StepProps) => {
    const {title, isFinished, semiFilled, isActive, index, onClick, id, disabled} = props;
    const circleClasses = cx(styles.circle, {[styles.active]: isActive});

    const onStepClick = useCallback(() => onClick(id), [id, onClick]);

    return (
        <div
            className={cx(styles.step, {
                [styles.finished]: isFinished && !isActive,
                [styles.semiFilled]: isActive && semiFilled,
                [styles.disabled]: disabled
            })}
        >
            <div className={circleClasses} onClick={onStepClick}>
                {isFinished && !isActive ? (
                    <Icon componentClasses={styles.icon} icon={PriorityIcon.check} />
                ) : (
                    index + 1
                )}
            </div>

            <Text
                componentClasses={cx(styles.title, {
                    [styles.activeTitle]: (isFinished && !isActive) || isActive
                })}
                skin="paragraph-1"
            >
                {title}
            </Text>
        </div>
    );
};
